import { createPortal } from 'react-dom';
import React, { useRef, useEffect, useContext } from 'react';
import './style.css';
import { FlaskConical, CircleX } from 'lucide-react';
import { WindowSizeContext } from '/src/App';
import RiskOverviewStandardSectionHeader from '/src/Components/RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import CTAButton from '/src/Components/CTAButton/CTAButton';



const HowToUseProjects = ({ projects, handleExploreProjectsClick }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const popupRef = useRef(null);


    const title = 'How to Navigate the Projects'

    // Filter based on the array for project_discounts_company_specific being at least 1
    const filteredProjects = projects.filter(project => project.project_discounts_company_specific.length > 0);

    // Select a random project from the filtered projects
    const randomProject = filteredProjects[Math.floor(Math.random() * filteredProjects.length)];


    const aboutProjectCardSentence = "Each project card shows the estimated cost, potential savings, available discounts, the climate risks it addresses, and whether it’s DIY-friendly."

    const thingsToDoOptions = [
        {
            text: 'Want to dive deeper into a project and see the full details? Double-click any card to view a complete project breakdown with guides and resources.',
            image: 'double-click-icon-green.png',
            imageMobile: 'double-click-icon-green.png',
        },
        {
            text: `Want to see how different project combinations pay off? Drag and drop projects into the Project Combo Lab to test your own scenarios.`,
            // image: 'drag-and-drop-icon-green.png',
            image: 'drag-handle-dots-green.png',
            imageMobile: 'drag-handle-dots-green.png',
        }
    ]


    useEffect(() => {
        const handleClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                handleExploreProjectsClick();
            }
        };

        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [handleExploreProjectsClick]);
    // Add effect to handle body scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';

        // Cleanup function to restore scrolling when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    return createPortal(
        <div className="what-if-machine-overlay">
            <div className={`how-to-use-projects-popup ${deviceType}`} ref={popupRef}>
                <div className="how-to-use-projects-popup-close-button-container">
                    <CircleX className="how-to-use-projects-popup-close-button" onClick={handleExploreProjectsClick} />
                </div>
                <div className="your-options-section-container">
                    <RiskOverviewStandardSectionHeader title={title} />
                    <div className={`how-to-use-projects-container ${deviceType}`}>
                        <div className="how-to-use-projects-left-container">

                            <ProjectsListCard
                                project={randomProject}
                                handleProjectClick={null}
                            />
                            <p className="how-to-use-projects-about-project-card-sentence text-align-center" dangerouslySetInnerHTML={{ __html: aboutProjectCardSentence }} />
                        </div>
                        <div className={`how-to-use-projects-divider ${deviceType}`} />
                        <div className={`how-to-use-projects-right-container ${deviceType}`}>
                            {thingsToDoOptions.map((option, index) => {

                                const image = deviceType === 'mobile' ? option.imageMobile : option.image;
                                
                                return (
                                    <div key={index} className="how-to-use-projects-thing-to-do-option">
                                        <div className="how-to-use-projects-thing-to-do-option-image-container">
                                            <img src={CreateCloudfrontUrl(image)} alt={option.text} />
                                        </div>
                                        <p className="how-to-use-projects-thing-to-do-option-text text-align-center" dangerouslySetInnerHTML={{ __html: option.text }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    {/* <CTAButton text="Explore The Projects!" onClick={handleExploreProjectsClick} /> */}

                </div>
            </div>
        </div>,
        document.body
    );
};

export default HowToUseProjects;